var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jz-button-group',{attrs:{"is-column-on-small-screen":""}},[_c('jz-button',{attrs:{"primary":""},on:{"click":_vm.handleButtonClick}},[_vm._v(_vm._s(_vm.derivedNextButtonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }